import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { RouteComponentProps, StaticContext, withRouter } from 'react-router';
import OrdersListItem from '../../components/OrdersListItem/OrdersListItem';
import { TOrder } from 'src/types/orders';
import ScrollableList from 'src/view/components/ScrollableList/ScrollableList';
import { CallCenterStore } from '~/mobx/ordersStore/callCenterStore';
import { LiveOrdersStore } from '~/mobx/ordersStore/liveOrdersStore';
import './style.scss';
import { LoadingStatus } from '~/types/main';

interface IProps extends RouteComponentProps<{ id: string }, StaticContext, TOrder> {
  store: LiveOrdersStore | CallCenterStore;
  onSelectOrder: (order: TOrder) => void;
  enableBlink?: boolean;
}

const OrdersList: React.FC<IProps> = observer(({ store, match, onSelectOrder, enableBlink = false }: IProps): JSX.Element | null => {
  useEffect(() => {
    if (store.ordersLoadingStatus === LoadingStatus.Init) {
      store.getOrders(0);
    }
  }, []);

  const renderOrderItem = (order: TOrder, index: number) => {
    return (
      <OrdersListItem
        onClick={onSelectOrder}
        key={order?.id || `order-${index}-key`}
        selected={match.params.id === order?.id}
        index={index}
        order={order}
        enableBlink={enableBlink}
      />
    );
  };

  if (store instanceof CallCenterStore && !store.orderListVisible) return null;
  return (
    <div className="orders-list d-flex flex-column">
      <ScrollableList<TOrder>
        fetch={store.getOrders}
        list={store.orders}
        loading={store.ordersLoadingStatus === LoadingStatus.Loading}
        refreshing={store.ordersLoadingStatus === LoadingStatus.Refreshing}
        current_page={store.pagination.currentPage}
        isHaveNextPages={store.isHaveNextPages}
        last_page={store.pagination.lastPage}
        pages={store.pages}
        byOffset
        renderItem={renderOrderItem}
        showEmptyListImage
        autoFetch={false}
        emptyListInFooter={false}
        scrollToTop
        scrollbar
      />
    </div>
  );
});

export default withRouter(OrdersList);
